import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import api from "@/lib/api";
import { DealCard } from "@/components/Cards";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/AuthContext";

export default function GroupDetail() {
    const { groupId } = useParams();
    const { user } = useAuth();
    const [group, setGroup] = useState(null);
    const [deals, setDeals] = useState([]);

    useEffect(() => {
        api.get(`/public/product-groups/${groupId}`).then((r) => {
            setGroup(r.data.group);
            setDeals(r.data.deals);
        });
    }, [groupId]);

    if (!group)
        return (
            <div className="mx-auto max-w-7xl px-6 py-24 text-navy-500">
                Loading…
            </div>
        );

    return (
        <>
            <section className="bg-white">
                <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-10 pb-8">
                    <Link
                        to="/browse"
                        data-testid="group-back"
                        className="inline-flex items-center gap-2 text-sm text-navy-500 hover:text-navy-700 mb-8"
                    >
                        <ArrowLeft size={15} /> Back to catalogue
                    </Link>

                    <div className="grid md:grid-cols-[1fr_320px] lg:grid-cols-[1fr_400px] items-center gap-8 md:gap-12">
                        <div>
                            <div className="text-xs uppercase tracking-[0.3em] text-gold-600 mb-3">
                                {deals.length} live perks · updated weekly
                            </div>
                            <h1 className="font-display text-5xl md:text-6xl text-navy-700 leading-[1.05] mb-4">
                                {group.name}
                            </h1>
                            <p className="text-navy-500 max-w-2xl leading-relaxed text-lg">
                                {group.description}
                            </p>
                        </div>
                        {group.hero_image && (
                            <img
                                data-testid="group-hero-image"
                                src={group.hero_image}
                                alt={group.name}
                                className="w-full max-w-[400px] h-auto object-contain mx-auto md:mx-0"
                            />
                        )}
                    </div>
                </div>
            </section>

            <section className="py-16 bg-cream">
                <div className="mx-auto max-w-7xl px-6 lg:px-10">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {deals.map((d) => (
                            <DealCard
                                key={d.id}
                                deal={d}
                                to={user?.role === "member" ? `/member/deals/${d.id}` : undefined}
                                footer={
                                    user?.role === "member" ? undefined : (
                                        <Link to="/signup">
                                            <Button
                                                data-testid={`unlock-${d.id}`}
                                                className="rounded-full bg-navy-700 hover:bg-navy-800 text-white h-10"
                                            >
                                                <Lock size={14} className="mr-2" /> Unlock as
                                                member
                                            </Button>
                                        </Link>
                                    )
                                }
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
